// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-p_gy","advertDetailServiceList__header":"c-p_gz","advertDetailServiceList__list":"c-p_gA"};